import { createFileRoute } from "@tanstack/react-router";

// ?branch= — bấm dòng ở bảng "Sức khoẻ từng cơ sở" mở bàn của cơ sở đó.
export const Route = createFileRoute("/_app/dashboard")({
  validateSearch: (s: Record<string, unknown>): { branch?: string } =>
    typeof s.branch === "string" && s.branch ? { branch: s.branch } : {},
});
